<div class="espace-wrapper">
  <section class="hero card-glass">
    <div>
      <p class="eyebrow">Spay · Porte‑monnaie électronique</p>
      <h1>Bienvenue dans votre espace client</h1>
      <p class="lead">
        Retrouvez vos comptes, transferts et preuves d’identité en un seul endroit, avec une interface clarifiée.
      </p>
      <div class="cta-row">
        <a class="btn btn-primary btn-pill" routerLink="/utilisateur/codes">Voir mes comptes</a>
        <a class="btn btn-outline-light btn-pill" routerLink="/utilisateur/transaction">Nouveau transfert</a>
      </div>
    </div>
    <div class="hero-badges">
      <span class="pill">Couleurs logo Spay</span>
      <span class="pill">Sécurité renforcée</span>
      <span class="pill">UI Bootstrap 5</span>
    </div>
  </section>

  <div class="row g-3 action-grid">
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
      <a class="action-card card-glass" routerLink="/utilisateur/codes">
        <div class="icon-circle">
          <i class="bi bi-wallet2"></i>
        </div>
        <div class="action-text">
          <h5>Mes comptes</h5>
          <p>Soldes, codes et activité des portefeuilles.</p>
        </div>
      </a>
    </div>

    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
      <a class="action-card card-glass" routerLink="/utilisateur/transaction">
        <div class="icon-circle">
          <i class="bi bi-arrow-bar-right"></i>
        </div>
        <div class="action-text">
          <h5>Transfert d’argent</h5>
          <p>Envoyer ou retirer rapidement avec confirmation.</p>
        </div>
      </a>
    </div>

    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
      <a class="action-card card-glass" routerLink="/utilisateur/statistiques">
        <div class="icon-circle">
          <i class="bi bi-arrow-repeat"></i>
        </div>
        <div class="action-text">
          <h5>Mes transactions</h5>
          <p>Historique consolidé avec filtres et exports.</p>
        </div>
      </a>
    </div>

    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
      <a class="action-card card-glass" routerLink="/informations/personel">
        <div class="icon-circle">
          <i class="bi bi-person-circle"></i>
        </div>
        <div class="action-text">
          <h5>Profil & infos</h5>
          <p>Identité, contacts, préférences et sécurité.</p>
        </div>
      </a>
    </div>

    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
      <a class="action-card card-glass" routerLink="/utilisateurs/identification">
        <div class="icon-circle">
          <i class="bi bi-person-check-fill"></i>
        </div>
        <div class="action-text">
          <h5>Identification</h5>
          <p>Envoyer et suivre vos justificatifs KYC.</p>
        </div>
      </a>
    </div>

    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
      <a class="action-card card-glass" routerLink="/utilisateurs/transferts">
        <div class="icon-circle">
          <i class="bi bi-shield-lock"></i>
        </div>
        <div class="action-text">
          <h5>Centre sécurité</h5>
          <p>Alertes, appareils de confiance et codes d’urgence.</p>
        </div>
      </a>
    </div>
  </div>
</div>
